import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "user-management"
};
const _hoisted_2 = {
  class: "content"
};
const _hoisted_3 = {
  class: "search-and-buttons"
};
const _hoisted_4 = {
  style: {
    "margin-left": "10px"
  }
};
const _hoisted_5 = {
  key: 0
};
const _hoisted_6 = {
  key: 0
};
import { ref, onMounted } from 'vue';
import { UserFilled } from '@element-plus/icons-vue';
import api from '@/server/request/api';
import { ElMessage } from "element-plus";
import { useRouter } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const bg = {
      backgroundColor: '#f8fafc'
    };
    onMounted(() => {
      getUserList();
    });
    const search = ref('');
    const userData = ref({
      username: '',
      dept: '',
      accounts: []
    });
    const ids = ref([]);
    const editUser = user => {
      api.saveSystemList(user).then(res => {
        if (res.code === 200) {
          ElMessage.success('修改成功');
          getUserList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const deleteUser = user => {
      let ids = {
        ids: user.id
      };
      api.deleteUser(ids).then(res => {
        if (res.code === 200) {
          ElMessage.success('删除成功');
          getUserList();
        } else {
          ElMessage.error(res.msg);
        }
      });
      // Logic to delete user
    };
    const handleSelectionChange = selection => {
      ids.value = selection.map(item => item.id);
    };
    // 获取用户列表
    const getUserList = async () => {
      const params = {
        userId: router.currentRoute.value.params.id
      };
      const res = await api.getSystemList(params);
      if (res.code === 200) {
        for (let i = 0; i < res.result.accounts.length; i++) {
          res.result.accounts[i].edit = false;
        }
        userData.value = res.result;
      } else {
        ElMessage.error(res.msg);
      }
    };
    const addUser = () => {};
    // 导出数据
    const exportData = () => {
      api.exportData({
        ids: ids.value.join(',')
      }).then(res => {
        // Create a Blob from the response data
        const blob = new Blob([res.result], {
          type: 'application/vnd.ms-excel'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'user_data.xlsx'); // Set the file name
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        ElMessage.success('数据导出成功');
      }).catch(() => {
        ElMessage.error('导出失败，请重试');
      });
    };
    const changeStatus = user => {
      api.editUser({
        id: user.id,
        status: user.status
      }).then(res => {
        if (res.code === 200) {
          ElMessage.success('修改成功');
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    // 批量删除
    const batchDelete = () => {
      api.deleteUser({
        ids: ids.value
      }).then(res => {
        if (res.code === 200) {
          ElMessage.success('删除成功');
          getUserList();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    // 将时间戳转为YYYY-MM-DD HH:MM:SS
    const formatTime = time => {
      const date = new Date(time);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_table = _resolveComponent("el-table");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "header"
      }, [_createElementVNode("div", {
        class: "title"
      }, "用户管理 > 帐号分配")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_avatar, {
        icon: _unref(UserFilled),
        size: 50
      }, null, 8, ["icon"]), _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", null, _toDisplayString(userData.value.username), 1), _createElementVNode("li", null, _toDisplayString(userData.value.dept), 1)]), _createElementVNode("div", null, [_createVNode(_component_el_button, {
        class: "btn",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).back())
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("返回", -1)]))]),
        _: 1
      })])]), _createVNode(_component_el_table, {
        data: userData.value.accounts,
        style: {
          "width": "100%"
        },
        "header-cell-style": bg,
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          type: "index",
          width: "55",
          label: "序号"
        }), _createVNode(_component_el_table_column, {
          prop: "sysName",
          label: "系统名称"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", null, _toDisplayString(scope.row.sysName), 1)]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "sysAccount",
          label: "帐号"
        }, {
          default: _withCtx(scope => [!scope.row.edit ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(scope.row.sysAccount), 1)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            modelValue: scope.row.sysAccount,
            "onUpdate:modelValue": $event => scope.row.sysAccount = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          prop: "sysPassword",
          label: "密码"
        }, {
          default: _withCtx(scope => [!scope.row.edit ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(scope.row.sysPassword), 1)) : (_openBlock(), _createBlock(_component_el_input, {
            key: 1,
            modelValue: scope.row.sysPassword,
            "onUpdate:modelValue": $event => scope.row.sysPassword = $event
          }, null, 8, ["modelValue", "onUpdate:modelValue"]))]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [!scope.row.edit ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            onClick: $event => scope.row.edit = true
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode("修改", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : (_openBlock(), _createBlock(_component_el_button, {
            key: 1,
            onClick: $event => editUser(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("保存", -1)]))]),
            _: 1
          }, 8, ["onClick"]))]),
          _: 1
        }), _cache[4] || (_cache[4] = _createTextVNode("+ ", -1))]),
        _: 1
      }, 8, ["data"])])]);
    };
  }
});